<template>
  <div id="customer-service" >
    <div class="header" >
      <div class="main" >
        <img src="@/assets/images/music.png">
        <span>咨询解答</span>
      </div>
    </div>
    <div class="wrapper" >
      <h2>常见问题</h2>
      <van-cell-group>
        <van-cell :title="item.title" is-link v-for="(item, index) in subjectList" :key="index" @click="routerGo(item.id)" />
      </van-cell-group>
    </div>
    <div class="line" ></div>
    <!--
    <footer class="footer" >
      <h3>人工服务</h3>
      <div class="btn" >
        <img src="@/assets/images/music.png">
        <span>在线客服</span>
      </div>
    </footer> -->
  </div>
</template>

<script>
import { getBMMarketSubjectList } from '@/api/match'
import { varConfig } from '@/utils/'
export default {
  name: 'CustomerService',
  data() {
    return {
      subjectList: []
    }
  },
  created() {
    this.getBMMarketSubjectList()
  },
  computed: {
  },
  methods: {
    getBMMarketSubjectList() {
      let params = {
        forumCategoryId: 9
      }
      getBMMarketSubjectList(params).then(response => {
        console.log(response)
        const list = response.data.subjectList
        let lists = []
        lists = list.map(item => {
          return {
            id: item.id,
            title: item.title
          }
        })
        this.subjectList = this.subjectList.concat(lists)
      })
    },
    routerGo(id) {
      if (!id) { return }
      let path = 'webapp-stage'
      if (process.env.ENV === 'prod') {
        path = 'webapp'
      } else if (process.env.ENV === 'pre') {
        path = 'webapp-pre'
      }
      const url = `${varConfig.siteUrl}/${path}/index.html?redirect=post-detail&id=${id}&type=customerService`
      window.location.assign(url)
    }
  }
}
</script>

<style lang="stylus" >
#customer-service
  .header
    background: rgba(19,146,255,1);
    .main
      display flex;
      height: 144px;
      justify-content: center;
      align-items: center;
      font-size:26px;
      font-weight:500;
      color:rgba(255,255,255,1);
      img
        width:47px;
        height:47px;
        border-radius:31px 31px 0px 31px;
        padding-right 10px
  .wrapper
    padding: 20px 0;
    h2
      font-size:20px;
      font-weight:400;
      color:rgba(0,0,0,1);
      line-height:28px;
      margin: 0;
      padding: 0 15px;
      padding-bottom 10px
    .van-cell-group
      .van-cell
        font-size:16px;
        font-weight:400;
        color:rgba(74,74,74,1);
        .van-cell__right-icon
          font-size: 14px
    .van-hairline--top-bottom::after
      border-width 0
    .van-cell:not(:last-child)::after
      left: 0
  .line
    background-color #F8F8F8
    height 10px
  .footer
    padding: 20px 15px;
    h3
      font-size:20px;
      font-weight:400;
      color:rgba(0,0,0,1);
      margin: 0;
    .btn
      display flex
      justify-content: center;
      align-items: center;
      width:128px;
      height:46px;
      background:rgba(19,146,255,1);
      border-radius:4px;
      margin-top: 15px
      img
        width:26px;
        height:26px;
        padding-right 10px
        border-radius:31px 31px 0px 31px;
      span
        font-size:16px;
        font-family:PingFangSC;
        font-weight:400;
        color:rgba(255,255,255,1);
</style>



// WEBPACK FOOTER //
// src/pages/customer-service/list.vue